module.exports = __webpack_public_path__ + "img/11-stylists-laserbeamer-popup.jpg";